'use strict';

var _ = require('lodash');
var ServiceShareDataProviderService = function ServiceShareDataProviderService($q, constants, featureToggleService, dataRetrieverService, marketAnalysisPanelService) {
  function getAggregatedShare(entry) {
    return featureToggleService.isEnabled('MAPPED_MODE') ? entry.regularAggregateShare : entry.mappedAggregateShare;
  }
  function calculateModelValue(group) {
    return _.reduce(group, function (sum, service) {
      sum += getAggregatedShare(service.entry);
      return sum;
    }, 0);
  }
  function normalize(input) {
    var atLeastOneValueGreaterThan1 = _.some(input, function (d) {
      return d.value > 1;
    });
    if (atLeastOneValueGreaterThan1) {
      var sum = _.sumBy(input, 'value');
      _.forEach(input, function (d) {
        if (!_.isNil(d.value) && sum > 0) {
          d.value = d.value / sum;
        }
      });
    }
    return input;
  }
  function roundPercentageMaximum(value) {
    return value > 1 ? 1 : value;
  }
  function transform(type, data) {
    if (_.isEmpty(data)) {
      return undefined;
    }
    var sumOfAllAggregatedShares = _.chain(data).values().flatMap().map(function (e) {
      return getAggregatedShare(e.entry);
    }).sum().value();
    var sortedData = _.chain(data).map(function (value, key) {
      return {
        key: key,
        value: value
      };
    }).sortBy(function (item) {
      if (type === 'demand-adjustment-fare') {
        return item.value[0].classIndex;
      }
      return item.key;
    }).value();
    var modelValues = _.map(sortedData, function (item) {
      return {
        groupId: item.key,
        value: roundPercentageMaximum(calculateModelValue(item.value) / sumOfAllAggregatedShares)
      };
    });
    var userValues = normalize(_.map(sortedData, function (item) {
      return {
        groupId: item.key,
        value: null
      };
    }));
    var serviceValues = _.reduce(sortedData, function (result, item) {
      _.forEach(item.value, function (d) {
        var id = d.entry.serviceClassId;
        result.model.push({
          groupId: id,
          value: getAggregatedShare(d.entry),
          bucketId: item.key,
          departureDate: d.departureDate,
          classGroup: d.entry.classGroup,
          significantPOS: d.entry.significantPOS
        });
        result.user.push({
          groupId: id,
          value: null,
          bucketId: item.key,
          departureDate: d.departureDate,
          classGroup: d.entry.classGroup,
          significantPOS: d.entry.significantPOS
        });
      });
      return result;
    }, {
      model: [],
      user: []
    });
    return $q.when({
      serviceShare: serviceValues,
      groupShare: {
        model: modelValues,
        user: userValues,
        effective: undefined
      }
    });
  }
  function filter(filterData, type, data) {
    if (type !== 'demand-adjustment-time-of-day' || _.keys(data).length === 1 || _.isEmpty(filterData.gridSelectionKeysMap) || _.isEmpty(data)) {
      return data;
    }
    var gridSelectionKeysMap = _.clone(filterData.gridSelectionKeysMap);
    _.each(data, function (groupedItems) {
      groupedItems = _.remove(groupedItems, function (item) {
        var gridSelectionKey = item.entry.market + '-' + item.departureDate + '-' + item.classGroup + '-' + item.entry.significantPOS;
        return !_.has(gridSelectionKeysMap, gridSelectionKey);
      });
    });
    return data;
  }
  function retrieveData(filterData, type) {
    return dataRetrieverService.getDataRetriever(constants.MARKET_SCREEN, constants.SERVICE_SHARE_MODE).retrieveData(type, marketAnalysisPanelService.buildServiceSearchRule(filterData)).then(function (data) {
      return $q.when(filter(filterData, type, data));
    }).then(function (data) {
      return $q.when(transform(type, data));
    });
  }
  return {
    retrieveData: retrieveData
  };
};
ServiceShareDataProviderService.$inject = ['$q', 'DataRetrieverConstantsService', 'FeatureToggleService', 'DataRetrieverService', 'MarketAnalysisPanelService'];
module.exports = ServiceShareDataProviderService;